export default __webpack_public_path__ + "static/media/placeholder_business05-nl-web.c0bcd55a.png";